import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RefererService {

    getReferer(): string {
        return document.referrer
    }
}
